//import { widgetApplication, open, close, restored } from './widget/widgetApplication';
import { WidgetApplication } from './widget/widgetApplication';
// EINE FUNKTION DIE WIR AM MESSAGE BUS REGISTRIERN, WIRD IM CONTEXT DES PLUGINS AUFGERUFEN
;
(function (document, window, bridge, options, extName) {
    'use strict';
    var version = '1.0.1';
    extName = extName || 'ChatUI';
    if (!bridge) {
        return;
    }
    /** construct settings from built-in default
     ** plus optinal options parameter
        ** Need this here before defining the built-in extensions
        ***********************************************/
    var settings = bridge.Helpers.extend({
    // default settings go here
    }, options);
    // I can supply my own configuration here!
    var startup = function (configuration) {
        new chatBotPlugin(extName, configuration).register();
    };
    /**
     * My Bridge2 Chatbot Plugin
    */
    var chatBotPlugin = function (name, configuration) {
        this.name = name;
        this.configuration = configuration;
    };
    var msgSink = function () {
        this.widget.handleBotInteractions("rawEvent", arguments[0]);
    };
    chatBotPlugin.prototype.register = function () {
        try {
            bridge.Logger.warn('Inside Plugin register');
            var entrypoint = function (name, msgBus, bridge) {
                var self = this;
                this.name = name;
                this.msgBus = msgBus;
                // this.interactionObject;
                bridge.Logger.debug('Plugin ' + this.name + ' is about to be registered');
                // this.configuration + '.getConfig', 'ChatUI');
                // console.log("WHAT IS MY CONFIGURATION " + this.configuration);
                /**
                 * NOTE to self (+Markus)
                    * To be on the safe side, attach the widget configuration and register the callback methods
                    * AFTER instantiating the widget. It is unsafe to assume that we'll be done creating the widget
                    * before the first event drops in - after all this is an asynchronous system
                    * The previously selected variant to wait until the widget is available is efficient but unnecessary
                    * and time consuming as wait() is timer-based and should only be used for situations where
                    * the event sequence cannot be controlled or predicted.
                    */
                // check prevents widget to be loaded in iframe
                if ((window.location === window.parent.location) || (window.location && window.location.pathname && window.location.pathname.indexOf("/network/nw") !== -1)) {
                    // Create a new WidgetApplication Object and initialize it
                    this.widget = new WidgetApplication(name, msgBus, bridge);
                    // no promise necessary, msgBus.async() already returns a promise!
                    self.msgBus.async(this.configuration + '.getConfig', 'ChatUI').then(function (config) {
                        self.widget.setConfiguration(config);
                        msgBus.subscribe('GenesysWebchat.ready', function () {
                            // console.log("GENESYSWEBCHAT RDY");
                            self.widget.setIntObject(msgBus.command('GenesysWebchat.registerExternalUI', msgSink));
                            // MSGBUS Register necessary commands
                            // as these commands depend on the intObject they should be registered _after_ setting it
                            self.msgBus.registerCommand('open', this.widget.open);
                            self.msgBus.registerCommand('close', this.widget.close);
                            // MSGBUS Subscribe to commands
                            self.msgBus.subscribe('*.*', function () {
                                // console.log.apply(null, arguments);
                                self.widget.handleMsgBusEvent.apply(self.widget, arguments);
                            });
                        });
                    });
                }
                // NOT NEEDED ANYMORE
                /*
                // Anonymous vs. Login via form to chat
                self.msgBus.subscribe('GenesysCommon.connectorsReady', () => {
                    registerChatPlugin(self.msgBus, msgSink, { requireEchoCancelling: false }).then((intObj) => {
                        bridge.Logger.warn('Register Chat Plugin', intObj);
                        self.widget.setIntObject(intObj);
                    });
                });
                */
                // After preparing the plugin - set the status to ready
                self.pluginReady();
            };
            var exitpoint = function () {
                bridge.Logger.warn('Plugin' + this.name + ' is about to be unregistered');
            };
            bridge.registerPlugin(this.name, entrypoint, exitpoint, this);
        }
        catch (e) {
        }
    };
    var apiDesc = {
        version: version,
        api: [{
                name: 'startup',
                closure: startup
            },],
    };
    bridge.registerExtension(extName, apiDesc);
})(document, window, window.Bridge2, {
// change these options if necessary
}, 'ChatUI');
